export class InternalServerError extends Error {
  code: number;

  constructor(message: string) {
    super(message);
    this.name = "Internal Server Error";
    this.code = 500;
  }
}
